import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";

/** "Anfahrt starten" — opens the work session; the phase derives from the stamped timestamp. */
export function useStartTaskTravel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: number }) =>
      taskApi.startTravel(id).then((r) => r.data),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: taskKeys.detail(vars.id) });
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
      // The live banner and the calendar both read `GET /schedule` state.
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
    },
  });
}
